import { forwardRef } from 'react';

type NavBarToggleButtonProps = {
  isExpanded: boolean;
  /** Compact desktop (1024–1279): the toggle opens/closes a floating drawer, not a push sidebar. */
  isDrawer?: boolean;
  /** Id of the sidebar panel this button controls (`aria-controls`). */
  controlsId?: string;
  onToggle(): void;
};

const NavBarToggleButton = forwardRef<HTMLButtonElement, NavBarToggleButtonProps>(
  ({ isExpanded, isDrawer = false, controlsId, onToggle }, ref) => {
    // In the compact band the toggle is the only way to read the icons, so it names the action
    // ("Abrir/Cerrar menú"); at >= 1280 it is a layout preference ("Expandir/Contraer").
    const label = isDrawer
      ? isExpanded
        ? 'Cerrar menú'
        : 'Abrir menú'
      : isExpanded
        ? 'Contraer menú'
        : 'Expandir menú';

    return (
      <button
        ref={ref}
        type="button"
        onClick={onToggle}
        title={label}
        aria-label={label}
        aria-expanded={isExpanded}
        aria-controls={controlsId}
        style={{
          position: 'absolute',
          right: -12,
          top: 28,
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: '#FFFFFF',
          border: '1px solid #E5ECEE',
          color: '#253746',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 1px 3px rgba(0,0,0,.08)',
          zIndex: 10,
          flexShrink: 0,
          padding: 0,
        }}
      >
        {isExpanded ? (
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M15 6l-6 6 6 6"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M9 6l6 6-6 6"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>
    );
  },
);

NavBarToggleButton.displayName = 'NavBarToggleButton';

export default NavBarToggleButton;
